// RFC-102: map Zustand + host camera into `ViewerState` for `encodeView()`.
import type { EngineId, ViewerCamera } from '@geosoft/viewer-sdk';
import { getTenantContext } from '@geosoft/platform-sdk';
import type { SavedView } from './useViewerStore';
import type { Scenario, ViewState, ViewerState } from './url/schema';

export function savedViewsToScenarios(views: SavedView[]): Scenario[] {
  return views.map((sv) => ({
    id: sv.id,
    label: sv.name,
    layerIds: [...sv.visibleLayerIds],
    pinnedTime: sv.time,
  }));
}

export function buildViewerStateForUrl(input: {
  camera: ViewerCamera | null;
  time: Date | null;
  visibleLayerIds: ReadonlySet<string>;
  primaryEngine: EngineId;
  savedViews: SavedView[];
  activeScenarioId: string | null;
  compareWithScenarioId: string | null;
}): ViewerState {
  const view: ViewState = {};
  if (input.camera) {
    view.center = [input.camera.lonLat[0], input.camera.lonLat[1]];
    if (input.camera.zoom != null) view.zoom = input.camera.zoom;
    if (input.camera.hpr) {
      view.heading = input.camera.hpr[0];
      view.pitch = input.camera.hpr[1];
    }
  }

  const hasViewKeys = view.center != null || view.zoom != null || view.heading != null || view.pitch != null;

  const scenarios = savedViewsToScenarios(input.savedViews);
  let orgAlias: string | undefined;
  try {
    orgAlias = getTenantContext().tenantId;
  } catch {
    orgAlias = undefined;
  }

  return {
    view: hasViewKeys ? view : undefined,
    time: input.time,
    visibleLayerIds: [...input.visibleLayerIds],
    primaryEngine: input.primaryEngine,
    scenarios: scenarios.length > 0 ? scenarios : undefined,
    activeScenarioId: input.activeScenarioId,
    compareWithScenarioId: input.compareWithScenarioId,
    orgAlias,
  };
}
